import React, { useContext, useEffect, useState, useRef } from 'react'
import Cookies from 'js-cookie'

import { trackClickEvent } from 'utils/Analytics'
import CloseIcon from 'Images/SVG/CloseBlack.svg'
import { FlexDiv } from 'components/generic/HomePageComponents'
import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { MainLoadingSkeleton } from 'components/Directories/Styled'
import { ImageCTABodyText } from 'components/Directories/CTAs/Styled'

import ReasonToHireMeCTAIcon from './ReasonToHireMeCTAIcon'
import {
  ReasonCTAContainer,
  NewBadge,
  ReasonCTATextContainer,
  ReasonCTATitle,
  AddAReasonCTAButton,
} from './Styled'
import { AppContext } from 'contexts/AppContext'

const ReasonToHireMeCTA = (props) => {
  const COOKIE_NAME = 'hideReasonToHireMeCTA'

  const [showCTA, setShowCTA] = useState(false)

  const containerRef = useRef()

  const reasonsToHireMeCookieValue = Cookies.get(COOKIE_NAME)
  useEffect(() => {
    const hideReasonToHireMeCTA = reasonsToHireMeCookieValue !== 'true'
    setShowCTA(!hideReasonToHireMeCTA)
  }, [reasonsToHireMeCookieValue])

  const hideReasonToHireMeCTA = () => {
    Cookies.set(COOKIE_NAME, 'true', { expires: 7 })
    containerRef.current.style.display = 'none'
    setShowCTA(false)
  }

  const addReason = (domain) => {
    const { reasonsEditLink } = props
    Cookies.set(COOKIE_NAME, 'true', { expires: 7 })
    trackClickEvent(domain, 'directory_add_a_reason')
    window.location.assign(reasonsEditLink)
  }

  const { domain } = useContext(AppContext)
  const { hasReasons, isLoading } = props

  if (hasReasons === false && showCTA === false) {
    if (isLoading === false) {
      return (
        <ReasonCTAContainer ref={containerRef}>
          <FlexDiv width={{ desktop: '60%' }} padding={{ _: '16px', desktop: '24px' }}>
            <FlexDiv width='100px' display={{ _: 'none', tablet: 'flex' }} mr='16px'>
              <ReasonToHireMeCTAIcon alt='Person Icon' />
            </FlexDiv>
            <ReasonCTATextContainer ml={{ _: '0.5rem', tablet: '0px' }}>
              <ReasonCTATitle display='inline-flex' fontSize={{ _: '18px', tablet: '20px' }}>
                <NewBadge>NEW</NewBadge>
                Reasons To Hire Me
              </ReasonCTATitle>
              <ImageCTABodyText color='textColor'>
                Strengthen your profile and stand out. Let employers know what makes you unique in
                the field.
              </ImageCTABodyText>
            </ReasonCTATextContainer>
          </FlexDiv>
          <AddAReasonCTAButton
            p={{ _: '6px 64px', tablet: '6px 36px', desktop: '16px' }}
            onClick={() => addReason(domain)}
          >
            Add a reason
          </AddAReasonCTAButton>
          <GenericLazyLoadImage
            src={CloseIcon}
            alt='Close'
            height='16px'
            width='16px'
            position='absolute'
            top='8px'
            right='8px'
            onClick={hideReasonToHireMeCTA}
          />
        </ReasonCTAContainer>
      )
    } else {
      return (
        <MainLoadingSkeleton
          mt='24px'
          minWidth={{ _: '335px', tablet: '390px', desktop: '945px' }}
          minHeight={{ _: '250px', tablet: '227px', desktop: '135px' }}
        />
      )
    }
  }
  return null
}

export default ReasonToHireMeCTA
